import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import styles from 'src/styles/common.module.scss'

export const TextHeaderFr = () => {
    const isDesktop = useMediaQuery('(min-width: 540px)')

    return (
        <HighlightedText
            text="GRATTEZ LES TICKETS ET RECEVEZ VOTRE BONUS"
            highlights={[
                { word: 'ET' },
                { word: 'RECEVEZ' },
                { word: 'VOTRE' },
                { word: 'BONUS' },
            ]}
            breakAfterWords={isDesktop ? ['TICKETS'] : ['ET']}
            className={styles.text_header}
        />
    )
}
